
<StageCard
	:type="type"
	tip-position="none"
	:compact="compact"
	:selected="selected"
	:data-qa-stage-node="nodeNumber"
	:data-qa-stage-status-name="statLabel"
	:data-qa-stage-status-text="statusText"
	:data-qa-stage-status-type="type"
	@click="handleClick"
>
	<template #header>
		<div class="title">stage {{ nodeNumber }}</div>
		<Icon
			v-if="!infoIconState.remove"
			:disabled="infoIconState.disabled"
			name="info"
			type="filled"
			size="medium"
			@click="handleIClick"
		/>
	</template>
	<StageStatistics
		:type="type"
		:name="statLabel"
		:number="nodeNumber"
		:status-text="statusText"
	/>
	<template #footer>
		<StageStatus :type="type" :status="status" />
	</template>
</StageCard>
